import { IS_PUBLIC, NO_AUTH_NEEDED } from '@/types';

const OnboardingSignupPage = () => import('@/onboarding/pages/onboarding-signup.vue');
const OnboardingSuccessPage = () => import('@/onboarding/pages/onboarding-success.vue');

export const onboardingRoutes = [
  {
    path: '/quickstart',
    name: 'quickstart-signup',
    component: OnboardingSignupPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-empty',
    },
  },
  {
    path: '/quickstart/success',
    name: 'quickstart-success',
    component: OnboardingSuccessPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-empty',
    },
  },
];
